import React, { useState, useEffect} from 'react';
import './Live.css';
import BoxVideo from '../components/BoxVideo';
import axios from 'axios';
import { domain } from '../variables';

function Live() {
    const [liveVideos, setLiveVideos] = useState([]);
    const [upcomingVideos, setUpcomingVideos] = useState([]);
    const MAX_VIDEOS = 10;

    useEffect(() => {
        if (liveVideos.length == 0) {
            getLiveVideos()
        }
        if (upcomingVideos.length == 0) {
            getUpcomingVideos()
        }
    }, [])

    const getLiveVideos = async () => {
        const link = domain + '/server/getVideos.php'
        await axios.post(
            link,
            {
                type: "live",
                limit: MAX_VIDEOS,
            }
        ).then(res => {
            const data = res.data;
            setLiveVideos(data.items);
        })
    }

    const getUpcomingVideos = async () => {
        const link = domain + '/server/getVideos.php'
        await axios.post(
            link,
            {
                type: "upcoming",
                limit: MAX_VIDEOS,
            }
        ).then(res => {
            const data = res.data;
            setUpcomingVideos(data.items);
        })
    }

    return ( 
        <div className="live_page">
            {/* // BANNIERE */}
            <div className={"top_banniere actus"}>
                <span className="top_banniere_title">
                    Live vidéo
                </span>
            </div>
            <div className="live_content">
                
                {
                    liveVideos.length == 0 && upcomingVideos.length == 0 &&
                    <h1>Pas de lives ou de lives à venir pour le moment...</h1>
                }
                
                {
                    liveVideos.map((item) => {
                        return (
                            <BoxVideo
                                key={item.id.videoId} 
                                title={item.snippet.title}
                                description={item.snippet.description}
                                embed={item.id.videoId}
                                type='EN DIRECT'
                                bColor='red'
                            />
                        )
                    })
                }
                
                {
                    upcomingVideos.map((item) => {
                        return (
                            <BoxVideo 
                                key={item.id.videoId} 
                                title={item.snippet.title}
                                description={item.snippet.description}
                                embed={item.id.videoId}
                                type='A VENIR'
                                bColor='black'
                            />
                        )
                    })
                }
            </div>
        </div>
     );
}

export default Live;